import { render, staticRenderFns } from "./RuleManagerHeader.vue?vue&type=template&id=5967b1ea&scoped=true&"
import script from "./RuleManagerHeader.vue?vue&type=script&lang=js&"
export * from "./RuleManagerHeader.vue?vue&type=script&lang=js&"
import style0 from "./RuleManagerHeader.vue?vue&type=style&index=0&id=5967b1ea&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5967b1ea",
  null
  
)

export default component.exports